export const ru = {
    'add-minus-keywords-pack-success': 'Набор успешно создан',
    'create-group-error': 'Ошибка при создании группы',
    'feed-not-exist': 'Такого фида не существует',
    'geo-empty-regions': 'Выберите регионы показа',
    'inconsistent-ad-group-type-to-campaign-type':
        'Тип создаваемой группы не соответствует типу кампании',
    'max-adgroups-in-campaign': 'Достигнут максимум групп в кампании',
    'name-empty': 'Не указано название группы',
    'name-max-length':
        'Название группы не может быть длиннее {maxLength} символов',
    'name-prohibited-symbols': 'Название группы содержит запрещенные символы',
    'no-rights-for-retargeting-edit':
        'Не поддерживается редактирование условий ретаргетинга для данного типа кампании',
    'warning-about-changes': 'Изменения не будут сохранены, продолжить?',
    'warning-about-changes-internal':
        'У вас есть несохранённые группы. Выйти без сохранения изменений?',
    'warning-about-empty-retargeting-conditions':
        'Вы сохраняете группу, которая будет таргетирована на всех пользователей в выбранном регионе. Продолжить?'
};
